import React from 'react';
import Typography from '@material-ui/core/Typography';
import { createStyles, WithStyles, withStyles } from '@material-ui/core/styles';
import get from 'lodash/get';

import { colors } from '../../../../../../themes/colors';
import { FormattedCoachingVisit } from '../../../../../../models/Sessions';
import { MemberSessionTimeTestID } from './constants';

interface MemberSessionTimeProps {
  visit: FormattedCoachingVisit;
}

const styles = (theme) =>
  createStyles({
    sessionTime: {
      fontSize: 14,
      color: colors.black4,
      width: 200,
    },
  });

type Props = WithStyles<typeof styles> & MemberSessionTimeProps;

const MemberSessionTime: React.FC<Props> = ({ classes, visit }) => {
  const startTime = visit.scheduledDateTime
    .setZone(get(visit, 'coachAssignment.member.localTimezone', 'utc') || 'utc')
    .toFormat("h:mm a 'UTC'ZZ");

  return (
    <div data-testid={MemberSessionTimeTestID}>
      <Typography className={classes.sessionTime}>{startTime}</Typography>
    </div>
  );
};

export default withStyles(styles)(MemberSessionTime);
